import { motion } from "framer-motion";

// "The Voice" — Shi writing on top of the sophisticated publication.
// Pink, italic, interruptive — used sparingly, never scrapbook-like.
export const ShiNote = ({
  children,
  className = "",
  rotate = "-rotate-3",
  delay = 0.2,
  testid,
}) => (
  <motion.span
    data-testid={testid}
    initial={{ opacity: 0, y: 8, rotate: 0 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={`pointer-events-none inline-block font-editorial italic text-neon ${rotate} ${className}`}
  >
    {children}
  </motion.span>
);
